import { SetStateAction, useEffect, useState } from 'react'
import { TitleH1 } from '../../../Components/CustomUi/titleH1'
import ViewPage from '../../../Components/ViewPage'
import { TabelaAbastecimento } from './components/tabela'
import { ContainerAbastecimento } from './styled'
import { ItensPerUserLogged } from '../../../services/login/permissaoUsuarioLoado'
import { FormularioAbastecimento } from './components/formulario'
import dayjs, { Dayjs } from 'dayjs'
import { AxiosResponse } from 'axios'
import { getEquipe, TypesEquipe } from '../../../services/Equipe'
import {
  useGetAtribuicaoFrota,
  useGetCategoriaPatrimonio,
} from '../../../services/Patrimonio/atribuicaoFrota/GET'
import {
  postAbastecimento,
  putAbastecimento,
  usePostAnaliseAi,
} from '../../../services/abastecimentos/POST'
import { useGetAbastecimento } from '../../../services/abastecimentos/GET'
import { maskCNPJ } from '../../../utils'
import { combustiveis } from '../patrimonioNovo/cadastro/components/gavetaPatrimonio/meta'
import { normalizarDecimal, normalizarValorInicial, removeMaskValor, removerDecimal } from '../../../services/Afins'
import { useDeleteAbastecimento } from '../../../services/abastecimentos/DELETE'

export interface PropsAbastecimento {
  estabelecimento: string
  cnpj: string
  endereco: string
  data: string
  hora: string
  combustivel: string
  litros: string
  precoporlitro: string
  valortotal: string
  formapagto: string
  numeroCupom: string
}

const dadosPagamento = [
  { forma: 'Dinheiro', cod: 1 },
  { forma: 'Cartão de crédito', cod: 2 },
  { forma: 'Cartão de débito', cod: 3 },
  { forma: 'Pix', cod: 4 },
  { forma: 'Boleto bancário', cod: 5 },
]

const Abastecimento: React.FC = () => {
  //TABELA
  const [permissions, setPermissions] = useState<ItensPerUserLogged>()
  const [pagination, setPagination] = useState<number>(15)
  const [page, setPage] = useState<number>(1)
  const [total, setTotal] = useState(null)
  const [open, setOpen] = useState(false)
  const [buscar_tabela, setBuscar_tabela] = useState<string>('')
  const [confirmar_exclusao, setConfirmar_exclusao] = useState<boolean>(false)
  const [id_item_atual, setId_item_atual] = useState<number>(null)
  const [nome_item_atual, setNome_item_atual] = useState<string>('')
  const [fake_loading, setFake_loading] = useState<boolean>(false)

  //FORMULARIO
  const [update, setUpdate] = useState(0)
  const [loadingSalvar, setLoadingSalvar] = useState(false)
  const [nome_posto, setNome_posto] = useState<string>('')
  const [cnpj, setCnpj] = useState<string>('')
  const [endereco, setEndereco] = useState<string>('')
  const [odom_atual, setOdom_atual] = useState<string>('')
  const [qntd_litros, setQntd_litros] = useState<string>('')
  const [valor_total, setValor_total] = useState<string>('')
  const [forma_pagamento, setForma_pagamento] = useState<string>('')
  const [forma_pagamento_id, setForma_pagamento_id] = useState<number>(null)
  const [tipo_combustivel, setTipo_combustivel] = useState<string>('')
  const [tipo_combustivel_id, setTipo_combustivel_id] = useState<number>(null)
  const [data, setData] = useState<Dayjs | null>(null)
  const [hora, setHora] = useState<string>('')
  const [tanque_cheio, setTanque_cheio] = useState<boolean>(false)
  const [usuario_selecionado, setUsuario_selecionado] = useState<string>('')
  const [usuario_selecionado_id, setUsuario_selecionado_id] = useState<number>(null)
  const [veiculo_selecionado, setVeiculo_selecionado] = useState<string>('')
  const [veiculo_selecionado_id, setVeiculo_selecionado_id] = useState<number>(null)
  const [frota, setFrota] = useState<string>('')
  const [selectedFile, setSelectedFile] = useState(null)
  const [base64File, setBase64File] = useState<string>('')
  const [dataEquipe, setDataEquipe] = useState([])
  const [dataVeiculos, setDataVeiculos] = useState([])
  const [imagePreview, setImagePreview] = useState<string | null>(null)

  //API
  const { data_categoria_patrimonio, refetch_data_categoria_patrimonio } =
    useGetCategoriaPatrimonio()
  const { carregando_abastecimento, data_abastecimento, refetch_data_abastecimento } =
    useGetAbastecimento(pagination, page, buscar_tabela)
  const { carregando_atribuicao, data_atribuicao, refetch_data_atribuicao } =
    useGetAtribuicaoFrota(-1)
  const { carregando_analise_ai, mutate_analise_ai, data_abastecimento_ai } = usePostAnaliseAi()
  const {carregando_deletar_abastecimento, mudateDeletarAbastecimento} = useDeleteAbastecimento()
  async function listarEquipe() {
    const response: AxiosResponse<TypesEquipe> = await getEquipe({
      pagination: -1,
      status: 1,
    })

    setDataEquipe(response.data.itens)
  }

  async function salvarAbastecimento() {
    setLoadingSalvar(true)
    const dataAbastecimento = {
      cod_veiculo: veiculo_selecionado_id,
      cod_usuario: usuario_selecionado_id,
      posto: {
        posto_nome: nome_posto,
        cnpj: cnpj,
        endereco: endereco,
      },
      abastecimento: {
        odom_atual: normalizarDecimal(odom_atual),
        qntd_litros: qntd_litros,
        valor_total: valor_total,
        tipo_combustivel: tipo_combustivel_id,
        data: data,
        hora: hora,
        tanque_cheio: tanque_cheio,
      },
      arquivo: selectedFile,
    }

    if (update <= 0) {
      const response = await postAbastecimento(dataAbastecimento, fecharGaveta, setLoadingSalvar)
    } else {
      const response = await putAbastecimento(
        dataAbastecimento,
        update,
        fecharGaveta,
        setLoadingSalvar
      )
    }
  }

  function abrirGaveta() {
    setOpen(true)
  }

  function limparCampos() {
    setNome_posto('')
    setCnpj('')
    setEndereco('')
    setOdom_atual('')
    setQntd_litros('')
    setValor_total('')
    setTipo_combustivel('')
    setTipo_combustivel_id(null)
    setData(null)
    setHora('')
    setTanque_cheio(false)
    setSelectedFile(null)
    setBase64File('')
  }

  function editarGaveta(cod) {
    setUpdate(cod)
    const filtrado = data_abastecimento?.itens.filter((item) => item?.cod === cod)
    setUsuario_selecionado(filtrado[0]?.usuario_nome)
    setUsuario_selecionado_id(filtrado[0]?.cod_usuario)
    setVeiculo_selecionado(filtrado[0]?.veiculo_nome)
    setVeiculo_selecionado_id(filtrado[0]?.cod_veiculo)
    setNome_posto(filtrado[0]?.nome_posto)
    setCnpj(maskCNPJ(filtrado[0]?.cnpj))
    setEndereco(filtrado[0]?.endereco)
    setTipo_combustivel(filtrado[0]?.tipo_combustivel_nome)
    setTipo_combustivel_id(filtrado[0]?.tipo_combustivel)
    setQntd_litros(normalizarValorInicial(filtrado[0]?.qntd_litros))
    setValor_total(removeMaskValor(filtrado[0]?.valor_total))
    setData(dayjs(filtrado[0]?.data))
    setHora(filtrado[0]?.hora)
    setFrota(filtrado[0]?.frota)
    setOdom_atual(removerDecimal(filtrado[0]?.odom_atual))
    setImagePreview(filtrado[0]?.cupom_fiscal_url)
    setTanque_cheio(filtrado[0]?.tanque_cheio)
    setOpen(true)
  }

  function deletar(cod) {
    setFake_loading(true)
    mudateDeletarAbastecimento({
      cod_abastecimento: cod,
      refetch_deletar: refetch_data_abastecimento
    })

    setTimeout(() => {
      setFake_loading(false)
    }, 800);
  }

  const handleImageChange = async (file: File | null, base) => {
    if (file !== null) {
      console.log('file', file)
      setBase64File(base)
      setSelectedFile(file)
    }
  }

  function fecharGaveta() {
    setOpen(false)
    setUpdate(0)
    setNome_posto('')
    setCnpj('')
    setEndereco('')
    setOdom_atual('')
    setQntd_litros('')
    setValor_total('')
    setTipo_combustivel('')
    setTipo_combustivel_id(null)
    setData(null)
    setHora('')
    setFrota('')
    setTanque_cheio(false)
    setUsuario_selecionado('')
    setUsuario_selecionado_id(null)
    setVeiculo_selecionado('')
    setVeiculo_selecionado_id(null)
    setBase64File('')
    setForma_pagamento('')
    setImagePreview(null)
    setSelectedFile(null)
    refetch_data_abastecimento()
  }

  useEffect(() => {
    if (data_categoria_patrimonio?.itens?.length > 0) {
      setDataVeiculos(data_categoria_patrimonio?.itens)
    }
  }, [data_categoria_patrimonio])

  useEffect(() => {
    if (usuario_selecionado_id !== null && update <= 0) {
      const filter = data_atribuicao?.itens.filter(
        (item) => item?.cod_usuario === usuario_selecionado_id
      )
      setVeiculo_selecionado(filter[0]?.veiculo_nome)
      setVeiculo_selecionado_id(filter[0]?.cod_veiculo)
      setFrota(filter[0]?.frota)
    }
  }, [usuario_selecionado_id])

  useEffect(() => {
    if (selectedFile !== null && base64File !== '') {
      mutate_analise_ai({
        base64: base64File?.replace(/^data:.*;base64,/, ''),
        mimeType: selectedFile?.type,
        refetch: undefined,
      })
    }
  }, [selectedFile, base64File])

  useEffect(() => {
    if (data_abastecimento_ai !== undefined) {
      const dados: PropsAbastecimento = data_abastecimento_ai?.data?.itens[0]
      const filterCombustivel = combustiveis.filter(
        (item) =>
          item.nome.toLowerCase() === dados?.combustivel?.trim().split(/\s+/)[0]?.toLowerCase()
      )
      const filterForma = dadosPagamento.filter(
        (item) => item?.forma.toLowerCase() === dados?.formapagto.toLowerCase()
      )
      setNome_posto(dados?.estabelecimento)
      setCnpj(maskCNPJ(dados?.cnpj))
      setEndereco(dados?.endereco)
      setTipo_combustivel(filterCombustivel[0]?.nome)
      setTipo_combustivel_id(filterCombustivel[0]?.cod)
      setQntd_litros(normalizarValorInicial(Number(dados?.litros)?.toFixed(2)))
      setValor_total(Number(dados?.valortotal)?.toFixed(2))
      setData(dayjs(dados?.data, 'DD/MM/YYYY'))
      setForma_pagamento(filterForma[0]?.forma)
      setForma_pagamento_id(filterForma[0]?.cod)
      setHora(dados?.hora)
    }
  }, [data_abastecimento_ai])

  useEffect(() => {
    listarEquipe()
    refetch_data_atribuicao()
    refetch_data_categoria_patrimonio()
    refetch_data_abastecimento()
  }, [])

  return (
    <ContainerAbastecimento>
      <ViewPage
        title='Abastecimento'
        btnClick={null}
        newHide
        rotina={109}
        onPermission={setPermissions}
        hiddeTitle
        cardBodyStyle={{ padding: 15 }}
        cardMainStyle={{ height: '87.5vh' }}
      >
        <div style={{ marginBottom: '10px' }}>
          <TitleH1>Abastecimento</TitleH1>
        </div>

        <TabelaAbastecimento
          loading={carregando_abastecimento}
          setPagination={setPagination}
          page={page}
          setPage={setPage}
          total={data_abastecimento?.total}
          listar_abastecimento={data_abastecimento?.itens}
          abrir={abrirGaveta}
          permissao={permissions}
          editar={editarGaveta}
          deletar={deletar}
          buscar_tabela={buscar_tabela}
          setBuscar_tabela={setBuscar_tabela}
          confirmar_exclusao={confirmar_exclusao}
          setConfirmar_exclusao={setConfirmar_exclusao}
          id_item_atual={id_item_atual}
          setId_item_atual={setId_item_atual}
          nome_item_atual={nome_item_atual}
          setNome_item_atual={setNome_item_atual}
          fake_loading={fake_loading}
        />

        <FormularioAbastecimento
          openForm={open}
          fecharGaveta={fecharGaveta}
          salvarAbastecimento={salvarAbastecimento}
          carregando_abastecimento={loadingSalvar}
          update={update}
          nome_posto={nome_posto}
          setNome_posto={setNome_posto}
          cnpj={cnpj}
          setCnpj={setCnpj}
          endereco={endereco}
          setEndereco={setEndereco}
          odom_atual={odom_atual}
          setOdom_atual={setOdom_atual}
          qtnd_litros={qntd_litros}
          setQtnd_litros={setQntd_litros}
          valor_total={valor_total}
          setValor_total={setValor_total}
          forma_pagamento={forma_pagamento}
          setForma_pagamento={setForma_pagamento}
          setForma_pagamento_id={setForma_pagamento_id}
          tipo_combustivel={tipo_combustivel}
          setTipo_combustivel={setTipo_combustivel}
          setTipo_combustivel_id={setTipo_combustivel_id}
          data={data}
          setData={setData}
          hora={hora}
          setHora={setHora}
          tanque_cheio={tanque_cheio}
          setTanque_cheio={setTanque_cheio}
          usuario_selecionado={usuario_selecionado}
          setUsuario_selecionado={setUsuario_selecionado}
          setUsuario_selecionado_id={setUsuario_selecionado_id}
          veiculo_selecionado={veiculo_selecionado}
          setVeiculo_selecionado={setVeiculo_selecionado}
          setVeiculo_selecionado_id={setVeiculo_selecionado_id}
          frota={frota}
          setFrota={setFrota}
          imagePreview={imagePreview}
          handleChangeImage={handleImageChange}
          loading_abastecimento_ai={carregando_analise_ai}
          data_equipe={dataEquipe}
          data_veiculos={dataVeiculos}
          data_pagamento={dadosPagamento}
          limparCampos={limparCampos}
          permissions={permissions}
        />
      </ViewPage>
    </ContainerAbastecimento>
  )
}

export default Abastecimento
